var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBankingAndPaymentsActivateCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-4644.000000, -704.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-banking-and-payments/Activate-card",
    transform: "translate(4644.000000, 704.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5740149,1.211 C17.5700141,0.455 16.3220131,0.007 14.969012,0.007 L6,0 C2.68600216,0 0,2.687 0,6 L0,13 C0,16.314 2.68600216,19 6,19 L9.65200775,19 L10.3250083,18.306 C11.1090089,17.498 12.1060097,17.07 13.2110106,17.07 C14.2420114,17.07 15.2970123,17.448 16.2610131,18.163 L16.3090131,18.198 L16.6600134,11.209 L16.8870136,6.699 L9.26500744,14.206 L2.85000229,7.916 C3.92300315,6.861 5.66300455,6.861 6.73700541,7.916 L9.26500744,10.387 L18.5740149,1.211 Z M20.1340162,7 C20.7220166,7.001 21.3460171,7.508 21.3470171,8.115 L21.5810173,17.379 C22.2700179,17.285 23.0780185,17.233 23.9570192,17.233 C24.4350196,17.233 24.93402,17.249 25.4480204,17.28 C26.9670217,17.374 28.5660229,17.674 29.6260238,17.96 C30.8280248,18.368 31.8150255,19.454 31.9060256,20.841 C32.0340257,22.807 32.0340257,25.522 31.8890256,26.539 C31.6190254,28.006 30.8500248,29.398 29.6370238,30.455 C28.4380228,31.499 26.9590216,32 25.4710204,32 C23.689019,32 21.8570175,31.318 20.5700165,29.91 C18.2950147,27.422 11.7620094,19.697 11.7620094,19.697 C12.1890098,19.256 12.6920102,19.07 13.2110106,19.07 C13.8430111,19.07 14.4990116,19.346 15.0700121,19.77 L18.0990145,22.427 L18.8180151,8.115 C18.8180151,7.508 19.5460157,7.001 20.1340162,7 L20.1340162,7 Z",
    id: 81
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBankingAndPaymentsActivateCard);
export default __webpack_public_path__ + "static/media/home-banking-and-payments-activate-card.4c04e6b4.svg";
export { ForwardRef as ReactComponent };